import React, { useState, useEffect } from 'react';
import CategoriesAndBrandsCard from './CategoriesAndBrandsCard';
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import ProductsCardOfTwo from './ProductsCardOfTwo';
import PWAHeader from '../common/PWAHeader';
import { fetch_store_components_v2 } from '../apiservices/ApiService';

const StoreCategoryGridPage = () => {
  const [categories, setCategories] = useState([]);
  const [pageId, setPageId] = useState(1); // Start with page 1
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Flag to check if more pages are available


  const type = localStorage.getItem("type");
  const typeId = localStorage.getItem("typeId");
  const productId = localStorage.getItem("productId");
  
  console.log("Type:", type);
  console.log("TypeId:", typeId);
  console.log("ProductId:", productId);
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  const fetchCategories = async (page) => {
    if (!hasMore || loading) return; // Avoid duplicate or unnecessary API calls

    setLoading(true);




    try {


      const productJson = JSON.stringify({
        type: type,
        typeId: typeId,
        pageId: page
      });
      const response = await fetch_store_components_v2({ productJson });


      if (response.code === 200 && response.data) {
        const newCards = response.data.cards?.map(card => card);
        if (newCards)
          setCategories((prevCategories) => [...prevCategories, ...newCards]);
        setHasMore(newCards != null && newCards.length > 0); // Check if there are more pages
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  // Initial Fetch
  useEffect(() => {
    fetchCategories(pageId);
  }, [pageId]);

  // Infinite Scroll Listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && hasMore && !loading) {
        setPageId((prevPageId) => prevPageId + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);

  // Fetch additional pages if content height is insufficient
  useEffect(() => {
    if (
      !loading &&
      hasMore &&
      document.body.offsetHeight <= window.innerHeight
    ) {
      setPageId((prevPageId) => prevPageId + 1);
    }
  }, [categories, loading, hasMore]);

  if (categories.length === 0 && !loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "1.5rem",
        }}
      >
        No Result
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "42rem", margin: "0 auto", display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header */}
      {/* <header
        style={{
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0.75rem 1rem",
          }}
        >
          <ChevronLeft onClick={() => goBack()} style={{ width: '24px', height: '24px' }} />

          <div
            style={{
              display: "flex",
              gap: "1rem",
              marginLeft: "10px",
            }}
          >
            Health Store
          </div>
        </div>
      </header> */}

      <PWAHeader title="Health Store" onBack={goBack} />

      {/* Categories */}
      {categories.map((category, key) => (
        <div key={key} style={{ backgroundColor: 'rgba(255, 152, 0, 0.11)' }}>
          {category.cardType === "22" ?
            <CategoriesAndBrandsCard card={category} /> :
            category.cardType === "19" ?
              <ProductsCardOfTwo
                product1={category.cardData[0]}
                product2={category.cardData[1]}
              /> :
              category.cardType === "18" ?
                <img src={category.cardData[0].data.imageUrl} width='100%' style={{ objectFit: 'cover' }} alt="Category" /> : ""
          }
        </div>
      ))}

      {/* Loading Indicator */}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "1rem 0",
            backgroundColor: "rgba(255, 152, 0, 0.11)", // Soft background for a subtle look
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Adds a slight elevation effect
          }}
        >
          {/* Spinner */}
          <div
            style={{
              width: "30px",
              height: "30px",
              border: "3px solid #e0e0e0",
              borderTop: "3px solid #007bff", // Blue spinner for an active feel
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginRight: "1rem", // Adds spacing between spinner and text
            }}
          ></div>

          {/* Loading Text */}
          <span
            style={{
              fontSize: "1rem",
              fontWeight: "500",
              color: "#555",
            }}
          >
            Loading more items...
          </span>

          {/* Spinner Animation */}
          <style>
            {`
         @keyframes spin {
           0% {
             transform: rotate(0deg);
           }
           100% {
             transform: rotate(360deg);
           }
         }
       `}
          </style>
        </div>
      )}
    </div>
  );
};

export default StoreCategoryGridPage;
